var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.dialogContainer,{tag:"component",attrs:{"dialog":_vm.dialog,"opts":_vm.dialogOpts},on:{"dialog-closed":function($event){return _vm.onClose()}}})}
var staticRenderFns = []

export { render, staticRenderFns }